import React from 'react'
import styled, { keyframes } from 'styled-components'

const Container = styled.div`
  position: relative;
  max-width: 600px;

  @media (max-width: 430px) {
    padding: 15px;
    margin: 20px auto;
  }
`

const AiUwResult = styled.h2`
  color: #2425aa;
  font-size: 22px;
  margin-bottom: 6px;
  font-weight: bold;

  @media (max-width: 430px) {
    font-size: 20px;
    font-weight: bold;
  }
`

const ContentContainer = styled.div`
  background-color: #dcdcea;
  padding: 40px 32px 32px 32px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 430px) {
    border-radius: 12px;
    font-weight: bold;
  }
`

const Text = styled.p`
  font-size: 20px;
  line-height: 1.5;
  color: #2425aa;
  margin: 0;

  @media (max-width: 430px) {
    font-size: 18px;
  }
`

const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: #dcdcea;
  padding: 40px 32px 32px 32px;
  text-align: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

  @media (max-width: 430px) {
    border-radius: 12px;
    font-weight: bold;
  }
`

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 3px solid #f3f3f3; /* Light grey border */
  border-top: 3px solid #2425aa; /* Blue border on top */
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`

const NotificationCard = ({ resultMessage, remarkMessage, requestStatus }) => {
  if (requestStatus !== 'requesting') {
    return (
      <Container>
        <ContentContainer>
          <AiUwResult>"{resultMessage}"</AiUwResult>
          <Text>{remarkMessage}</Text>
        </ContentContainer>
      </Container>
    )
  } else {
    return (
      <Container>
        <SpinnerContainer>
          <Spinner />
        </SpinnerContainer>
      </Container>
    )
  }
}

export default (hoc) => hoc(NotificationCard)
